import React, { useState, useEffect } from 'react';

// Types
import { Workspace, TemplateWizardStateType } from 'Shared/types/Workspace.type';

// Components
import AgendaBuilderStartScreen from './_partials/AgendaBuilderStartScreen';
import AgendaBuildScreen from './_partials/AgendaBuildScreen';
import AgendaApplyStep from './_partials/AgendaApplyStep';

// Styles
import './AgendaBuilder.scss';

export enum AgendaBuilderSteps {
  start = 'start',
  build = 'build',
  apply = 'apply',
}

type Props = {
  workspace: Workspace;
};
const AgendaBuilder = ({ workspace }: Props) => {
  const [step, setStep] = useState<AgendaBuilderSteps>(AgendaBuilderSteps.start);

  useEffect(() => {
    if (workspace.templateWizardState === TemplateWizardStateType.INITIALIZED) setStep(AgendaBuilderSteps.build);
  }, []);

  if (step === AgendaBuilderSteps.start)
    return <AgendaBuilderStartScreen workspace={workspace} handleSetState={setStep} />;
  if (step === AgendaBuilderSteps.build) return <AgendaBuildScreen workspace={workspace} handleSetState={setStep} />;
  if (step === AgendaBuilderSteps.apply) return <AgendaApplyStep workspace={workspace} handleSetState={setStep} />;
};

export default AgendaBuilder;
